__turbopack_context__.v({
  "card": "ParagraphAudienceMatch-module__ooBxoW__card",
  "cardDesc": "ParagraphAudienceMatch-module__ooBxoW__cardDesc",
  "cardName": "ParagraphAudienceMatch-module__ooBxoW__cardName",
  "cardText": "ParagraphAudienceMatch-module__ooBxoW__cardText",
  "checkIcon": "ParagraphAudienceMatch-module__ooBxoW__checkIcon",
  "eyebrow": "ParagraphAudienceMatch-module__ooBxoW__eyebrow",
  "grid": "ParagraphAudienceMatch-module__ooBxoW__grid",
  "header": "ParagraphAudienceMatch-module__ooBxoW__header",
  "intro": "ParagraphAudienceMatch-module__ooBxoW__intro",
  "notes": "ParagraphAudienceMatch-module__ooBxoW__notes",
  "notesDash": "ParagraphAudienceMatch-module__ooBxoW__notesDash",
  "notesItem": "ParagraphAudienceMatch-module__ooBxoW__notesItem",
  "notesList": "ParagraphAudienceMatch-module__ooBxoW__notesList",
  "notesTitle": "ParagraphAudienceMatch-module__ooBxoW__notesTitle",
  "section": "ParagraphAudienceMatch-module__ooBxoW__section",
  "title": "ParagraphAudienceMatch-module__ooBxoW__title",
});
